/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Feb 2023
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './BookingActions.module.css';
import Button from '../../../../components/Button';
import { Actions, isActionVisible } from './action-utils';

const BookingActions = ({
  selectedBooking,
  onClosePopup,
  onBookingActionClick,
}) => {

  return (
    <div className={classes.container}>
      <div className={classes.closeBtn} onClick={onClosePopup}>X</div>
      <div className={classes.buttonWrapper}>
        {Actions.slice(0, Actions.length - 2).map(action => {
          const visible = isActionVisible(selectedBooking, action.type)
          return (
            <Button
              key={`id-${action.id}-${action.type}`}
              disabled={!visible}
              onClick={() => onBookingActionClick(action.type)}
              className={classes.actionBtn}>
              <img src={action.icon} alt={'Img'} className={classes.icon} />
              <div className={classes.actionBtnTxt}>{action.label}</div>
            </Button>
          )
        })}
      </div>
    </div>
  );
};

export default BookingActions;

BookingActions.propTypes = {
  onClosePopup: PropTypes.func,
  onBookingActionClick: PropTypes.func,
  selectedBooking: PropTypes.object,
};

BookingActions.defaultProps = {
  onClosePopup: () => { },
  onBookingActionClick: () => { },
  selectedBooking: {},
};
